module.exports = __webpack_public_path__ + "img/bubble_layout_4.cc768650.svg";